'use strict';

var _ = require('lodash');
var angular = require('angular');
var MarketAnalysisModeController = function MarketAnalysisModeController($scope, $rootScope, $controller, dataRetrieverConstantsService, userPreferencesService) {
  $scope.mode = dataRetrieverConstantsService.MARKET_MODE;
  $scope.kpiRibbonCollapsed = userPreferencesService.getUserSettingComponent('collapseKpis');
  $scope.showKpiTarget = userPreferencesService.getUserSettingComponent('showKpiTarget');
  $scope.dataReady = true;
  angular.extend(this, $controller('AnalysisModeController', {
    $scope: $scope
  }));
  $scope.defaultBrushFilters = {};
  $scope.triggerChangeFilter = function () {
    $scope.changeFilter({
      brushData: _.extend({}, $scope.defaultBrushFilters, $scope.brushFilters),
      gridRows: $scope.selectedRows
    });
  };
  $scope.onRowSelection = function (event, selectedRows) {
    $scope.screenState.selectedRows = selectedRows;
  };
  $scope.onDefaultBrushFilter = function (event, brushFilter) {
    if (!brushFilter.isEmpty()) {
      $scope.defaultBrushFilters[brushFilter.filterType] = brushFilter;
    } else {
      delete $scope.defaultBrushFilters[brushFilter.filterType];
    }
    $scope.triggerChangeFilter();
  };
  function triggerSearch() {
    $scope.$broadcast('search-criteria:searchChangeEvent');
  }
  $scope.$on('market-mode-search-criteria:searchChangeEvent', triggerSearch);
  function resetOneDaySelectionAtOtherTabs(brushSelectionFilter) {
    if (areMultipleDaysSelected(brushSelectionFilter)) {
      $rootScope.$broadcast('market-analysis:resetDaysSelection', false);
    }
  }
  function areMultipleDaysSelected(brushSelectionFilter) {
    if (brushSelectionFilter.filterType === 'dateRange' && !brushSelectionFilter.isEmpty()) {
      var filterArguments = brushSelectionFilter.filterArguments[0];
      return filterArguments.length > 1 || filterArguments[0].from.valueOf() !== filterArguments[0].to.valueOf();
    }
    return false;
  }
  $scope.onBrushFilter = function (event, brushSelectionFilter) {
    resetOneDaySelectionAtOtherTabs(brushSelectionFilter);
  };
  $scope.$on('brush-filter:filterApplied', $scope.onBrushFilter);
};
MarketAnalysisModeController.$inject = ['$scope', '$rootScope', '$controller', 'DataRetrieverConstantsService', 'UserPreferencesService'];
module.exports = MarketAnalysisModeController;